export const SECOND_IN_MILLIS = 1000;
export const MINUTE_IN_MILLIS = 60 * SECOND_IN_MILLIS;
export const HOUR_IN_MILLIS = 60 * MINUTE_IN_MILLIS;
export const DAY_IN_MILLIS = 24 * HOUR_IN_MILLIS;
